<template>
  <div class="region">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="地区名称">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="地区编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="父级地区">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.parentCode" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="地区编码"
            align="center">
        </el-table-column>
        <el-table-column
            prop="parentCode"
            align="center"
            label="父级编码">
        </el-table-column>
        <el-table-column
            prop="levelName"
            align="center"
            label="层级">
        </el-table-column>
        <el-table-column
            prop="note"
            align="center"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="地区编码" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="层级">
                    <el-select v-model="ruleForm.level" placeholder="请选择层级" style="width: 100%">
                      <el-option label="国家" value="1"></el-option>
                      <el-option label="省" value="2"></el-option>
                      <el-option label="市" value="3"></el-option>
                      <el-option label="县或者区" value="4"></el-option>
                    </el-select>
        </el-form-item>
        <el-form-item label="上级" v-if="dialogVisible">
        <el-cascader :props="props" v-model="ruleForm.parentCode" ref="cascader" @change="cascaderChange" style="width: 100%"></el-cascader>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "region",
  data() {
    let _that=this
    return {
      props: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let id=node.level===0?'':node.value // 初始化不需要id
         let data=await _that.TreeArea(id)
          const nodes =data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
          resolve(nodes);
        }
      },
      tableData: [],
      searchForm: {
        name: '',
        code: '',
        parentCode: '',
      },
      modelTitle: '新增地区',
      dialogVisible: false,
      ruleForm: {
        name: '',
        code: '',
        level: '',
        note: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'},
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    TreeArea(id){
      return this.axios.get('api/Area/GetTreeNode?code=' + id).then(res=>{
        return res
      })
    },
    cascaderChange(e){
      this.ruleForm.parentCode=e[e.length-1]
    },
    clear() {
      this.searchForm = {
        name: '',
        code: '',
        parentCode: ''
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    addItem() {
      this.modelTitle = '新增地区'
      this.ruleForm = {
        name: '',
        code: '',
        level: '1',
        note: '',
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑地区'
      this.areaId = row.id
      this.ruleForm = {
        name: row.name,
        code: row.code,
        level: String(row.level),
        note: row.note,
        parentCode:row.parentCode
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            level: Number(this.ruleForm.level),
            parentCode: this.ruleForm.parentCode,
          }
          if (this.modelTitle === '编辑地区') {
            this.axios
                .put("api/Area?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                 .post("api/Area", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // deleteClick(flag) {
    //     let data = {
    //       id: flag.id
    //     }
    //     this.axios
    //         .put("api/GroupPrivilege//api/Area", {params:data}).then((res) => {
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success'
    //       });
    //     }).finally(error=>{
    //       this.init()
    //     })
    // },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        parentCode: this.searchForm.parentCode,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/Area", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item => {
              switch (item.level) {
                case 1:
                  item.levelName = '国家'
                  break;
                case 2:
                  item.levelName = '省'
                  break;
                case 3:
                  item.levelName = '市'
                  break;
                case 4:
                  item.levelName = '县或者区'
                  break;
              }
            })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.classification {

}
</style>